import React, { useState, useEffect } from "react";
import { TbFileInvoice } from "react-icons/tb";
import { CgSandClock } from "react-icons/cg";
import { FaCrown } from "react-icons/fa";
import {
  IoIosArrowForward,
  IoIosArrowDown,
  IoIosAddCircle,
  IoMdSearch,
} from "react-icons/io";
import BookingDatas from "../BookingDatas/BookingDatas";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import AddBooking from "../../BookingSection/AddBooking";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import AddStaff from "../../Staff/AddStaff/AddStaff";
import Cookies from "js-cookie";
function LeftDashboardSection({ bookingData }) {
  const { id } = useParams();
  console.log("iddddd", id);
  const [active, setActive] = useState("all");
  const [filtered, setFiltered] = useState("");
  const [storeCardTitle, setStoreCardTitle] = useState("");
  const [customer, setCustomer] = useState([]);
  const [staff, setStaff] = useState([]);
  const [service, setService] = useState([]);
  const [product, setProduct] = useState([]);
  const [fullname, setFullname] = useState("");

  const getCustomer = () => {
    axios
      .get("/booking")
      .then((res) => {
        console.log(res);
        setCustomer(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getStaff = () => {
    axios
      .get("/staff")
      .then((res) => {
        console.log(res);
        setStaff(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getProduct = () => {
    axios
      .get("/product")
      .then((res) => {
        // console.log(res);
        setProduct(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getService = () => {
    axios
      .get("/service")
      .then((res) => {
        // console.log(res);
        setService(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getCustomer();
    getStaff();
    getProduct();
    getService();
  }, []);
  const card = [
    {
      title: " add Customers",
      desc: "add customers details  here",
      icon: <TbFileInvoice className="w-7 h-7" />,
    },
    {
      title: "create booking ",
      desc: "Add booking offline and manage it here",
      icon: <IoIosAddCircle className="w-7 h-7" />,
    },
    {
      title: "memberships plan",
      desc: "Create and sare invoices in  seconds",
      icon: <FaCrown className="w-7 h-7" />,
    },
    // {
    //   title: "waitlist ",
    //   desc: "Add booking offline and manage it here",
    //   icon: <CgSandClock className="w-7 h-7" />,
    // },
  ];
  const overview = [
    { number: bookingData?.length, title: "bookings" },
    { number: product?.length, title: "total product" },
    { number: customer?.length, title: "total staff" },
    { number: service?.length, title: "services" },
    { number: customer?.length, title: "customers" },
  ];
  const tabs = [
    { title: "all" },
    { title: "pending" },
    { title: "accepted" },
    { title: "completed" },
    { title: "rejected" },
  ];
  useEffect(() => {
    setFullname(Cookies.get("username"));
  }, [fullname]);
  console.log(fullname.split("@gmail.com"));

  let mod;
  switch (active) {
    case "all":
      mod = (
        <BookingDatas
          bookingData={bookingData}
          filtered={filtered}
          active="all"
        />
      );

      break;
    case "rejected":
      mod = (
        <BookingDatas
          bookingData={bookingData}
          filtered={filtered}
          active="rejected"
        />
      );

      break;
    case "pending":
      mod = (
        <BookingDatas
          bookingData={bookingData}
          filtered={filtered}
          active="pending"
        />
      );

      break;
    case "completed":
      mod = (
        <BookingDatas
          bookingData={bookingData}
          filtered={filtered}
          active="completed"
        />
      );

      break;
    case "accepted":
      mod = (
        <BookingDatas
          bookingData={bookingData}
          filtered={filtered}
          active="accepted"
        />
      );

      break;

    default:
      break;
  }
  const allTabs = (val) => {
    setActive(val);
  };
  const handleChange = (e) => {
    // console.log("first");
    setFiltered(e.target.value);
  };
  // const handleCardTitle = (title) => {
  //   setStoreCardTitle(title);
  // };
  // let mods;
  // switch (storeCardTitle) {
  //   case "create booking ":
  //     mods = <AddBooking />;
  //     break;
  //     let mods;
  //     switch (storeCardTitle) {
  //       case "create booking ":
  //         mods = <AddBooking />;
  //         break;

  //       default:
  //         break;
  //     }
  //   default:
  //     break;
  // }
  return (
    <div className="  w-full tablet:w-full mx-auto ">
      <div className="font-bold text-gray-500 text-xs">
        Tuesday 24 june 2022
      </div>
      <div className=" capitalize font-semibold text-xl text-gray-700">
        good morning {fullname.split("@gmail.com")} ,
      </div>
      <div
        className="my-3 grid grid-cols-2  tablet:grid-cols-3
       laptopM:grid-cols-3 laptopL:grid-cols-3 gap-4 "
      >
        {card.map((val, i) => {
          return (
            <Link to={`/dashboard/${val.title}`} key={i}>
              <div
                className="bg-white rounded-md  cursor-pointer px-2 py-6"
                // onClick={() => handleCardTitle(val.title)}
              >
                <div className="text-yellow-400 my-1.5">{val.icon}</div>
                <div
                  className="flex justify-between text-sm tablet:text-base font-bold 
                capitalize text-gray-700 items-center my-1"
                >
                  <div className=""> {val.title}</div>
                  <div>
                    {" "}
                    <IoIosArrowForward className="w-3 h-3  " />
                  </div>
                </div>
                <div className="text-xs text-gray-500 h-8 line-clamp-2">
                  {val.desc}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="  border-b border-gray-300  my-8"></div>{" "}
      <div>
        <div className="flex justify-between   items-center">
          <div className="capitalize font-bold">overview</div>
          <div className="capitalize  px-2 text-sm flex gap-2 font-semibold text-gray-500 items-center">
            <div> this month</div>
            <div>
              <IoIosArrowDown className="w-4 h-4  " />
            </div>
          </div>
        </div>
        <div className="my-3 grid grid-cols-2   tablet:grid-cols-5 gap-4 ">
          {overview.map((val, i) => {
            return (
              <div
                className="bg-white rounded-md  cursor-pointer px-3 py-2"
                key={i}
              >
                <div className="  text-yellow-500 font-bold text-lg">
                  {val.number}
                </div>

                <div className=" font-bold capitalize text-xs text-gray-500  my-1">
                  {val.title}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="  border-b border-gray-300 my-8 "></div>
      <div>
        <div className="  ">
          <div className="capitalize font-bold">bookings</div>
          <div
            className="capitalize  text-sm   rounded-md px-2 my-4 bg-white
           border-gray-400 flex gap-2 font-semibold text-gray-500 items-center"
          >
            <div className="w-full ">
              <input
                type="text"
                name="booking"
                placeholder="Search by Status or Booking Number or Price ..."
                className="py-3 px-1.5 rounded-md placeholder:text-sm placeholder:font-light  w-full"
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div>
              <IoMdSearch className="w-6 h-6  text-gray-400 " />
            </div>
          </div>
        </div>
        <div className="relative mb-4  ">
          <div className="my-1.5 flex  items-center gap-3  mobileL:gap-8">
            {tabs.map((val, i) => {
              return (
                <div className="  " key={i}>
                  <button
                    className={` font-semibold capitalize  ${
                      active === val.title
                        ? "text-black border-b-2 border-yellow-500"
                        : "text-gray-400"
                    }  my-1`}
                    onClick={() => allTabs(val.title)}
                  >
                    {val.title}
                  </button>
                </div>
              );
            })}
          </div>
          <div className="  border-b  w-full  absolute bottom-1 border-gray-300 "></div>
        </div>
        <div>
          <div className="flex   justify-between items-center">
            <div className="uppercase text-gray-400 text-xs font-bold">
              all orders
            </div>
            <div className="capitalize  px-2 text-sm flex gap-2 font-semibold text-gray-500 items-center">
              <div> this month</div>
              <div>
                <IoIosArrowDown className="w-4 h-4  " />
              </div>
            </div>
          </div>
          {mod}
        </div>
      </div>
    </div>
  );
}

export default LeftDashboardSection;
